import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { appService } from '../../../../app/_services/app.service';
import { CommonService } from '../../../../app/_services/common.service';
import { EwayBillService } from '../../services/EwayBill/eway-bill.service';
import { MobileDetectionService } from '../../services/mobile-detection.service';
import { OrdersService } from '../../services/orders/orders.service';
import { CookieService } from 'ngx-cookie-service';
import { DecryptPipe } from '../../../../app/auth/_services/encrypt-decrypt.pipe';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-change-trans-veh-driver',
  templateUrl: './change-trans-veh-driver.component.html',
  styleUrls: ['./change-trans-veh-driver.component.scss']
})
// Added by priya - 09/02/2026 - cn(PRIYA-JAN26-017)
export class ChangeTransVehDriverComponent implements OnInit {

  static that: ChangeTransVehDriverComponent;
  @Output() onCloseEvent = new EventEmitter<any>();
  @Input() data: any = {};
  dataY: any = {};
  CompanyGSTIN: any;
  CompanyId: any;
  userId: any;
  TenantId: any;
  hasEditAccess: Boolean = true;
  isFormSubmit: boolean = false;
  // EwayBillNo: any;
  TransporterIdForEway: any;
  VehicleIdForEway: any;
  IsChangedTransDriVeh: boolean = false;
  EwayConsignmentList: any = [];
  Transporter: any = {
    lable: 'Transporter',
    formControlName: 'Transporter',
    dataField: 'Transporter',
    isRequired: true,
    placeholder: 'Select Transporter',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };
  VehicleNo: any = {
    lable: 'VehicleNo',
    formControlName: 'VehicleNo',
    dataField: 'VehicleNo',
    isRequired: true,
    placeholder: 'Select Vehicle No',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };
  Driver: any = {
    lable: 'Driver',
    formControlName: 'Driver',
    dataField: 'Driver',
    isRequired: true,
    placeholder: 'Select Driver',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };
  DriverMobileNo = {
    lable: 'Driver Mobile No',
    formControlName: 'DriverMobileNo',
    dataField: 'DriverMobileNo',
    isRequired: true,
    placeholder: 'Enter Driver Mobile No',
  };
  DriverLicense = {
    lable: 'Driver License No',
    formControlName: 'DriverLicense',
    dataField: 'DriverLicense',
    placeholder: 'Enter Driver License No',
  };
  RCBookNo = {
    lable: 'RC Book No',
    formControlName: 'RCBookNo',
    dataField: 'RCBookNo',
    placeholder: 'Enter RC Book No',
  };
  ChassisNo = {
    lable: 'Chassis No',
    formControlName: 'ChassisNo',
    dataField: 'ChassisNo',
    placeholder: 'Enter Chassis No',
  };
  EngineNo = {
    lable: 'Engine No',
    formControlName: 'EngineNo',
    dataField: 'EngineNo',
    placeholder: 'Enter Engine No',
  };
  Reason: any = {
    lable: 'Change Reason',
    formControlName: 'Reason',
    dataField: 'Reason',
    isRequired: true,
    placeholder: 'Select Reason',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };
  EwayBillNo = {
    lable: 'EwayBill No',
    formControlName: 'EwayBillNo',
    dataField: 'EwayBillNo',
    isRequired: false,
    type: 'number',
    maxlength: 12,
    placeholder: 'Enter EwayBill No',
  };

  constructor(
    private orderService: OrdersService,
    private _appService: appService, 
    private toastr: ToastrService,
    private router: Router, 
    private route: ActivatedRoute,
    private commonService: CommonService,
    private Eway: EwayBillService,
    private mobileDetectionService: MobileDetectionService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
    private translate: TranslateService,
  ) { 
    ChangeTransVehDriverComponent.that = this;
  }

  ngOnInit() {
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.CompanyGSTIN = JSON.parse(localStorage.getItem('ChnageCompnayId')).SelectedCompantGSTIN;
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    this.hasEditAccess = this.commonService.CheckHasRight('EDIT', 'NETWORK_DETAILS');
    this.TenantId = JSON.parse(localStorage.getItem("ChnageCompnayId")).TenantId;
    this.dataY.BookingId = this.data.BookingId;
    this.dataY.Transporter = this.data.TransporterId.toLowerCase();
    this.dataY.TransporterName = this.data.TransporterName.toLowerCase();
    this.dataY.VehicleNo = this.data.VehicleNo;
    this.dataY.Driver = this.data.DriverId;
    this.dataY.driverName = this.data.DriverName;
    this.dataY.DriverLicense = this.data.LicenseNo;
    this.dataY.RCBookNo = this.data.RCBookNo;
    this.dataY.ChassisNo = this.data.ChassisNo;
    this.dataY.EngineNo = this.data.EngineNo;
    this.dataY.DriverMobileNo = this.data.DriverMobileNo;
    this.dataY.TransporterType = this.data.TransporterType;
    this.dataY.Reason = this.data.ChangeReason;
    this.dataY.EwayBillNo = this.data.EwayBillNo;
    this.GetTransporterList(this.dataY.TransporterName, false);
    this.GetVehicleNoList(this.dataY.VehicleNo, false);
    this.GetReasonList(this.data.ChangeReasonName, false);
    this.Driver.dropdownList = [];
    let obj: any = {};
    obj.name = this.data.DriverName;
    obj.value = this.data.DriverId;
    this.Driver.dropdownList.push(obj);
    this.TransporterIdForEway = this.data.TransporterId;
    this.VehicleIdForEway = this.data.VehicleNo;
    // if (this.EwayBillFiling) {
    if (this.VehicleIdForEway === this.dataY.VehicleNo && this.TransporterIdForEway === this.dataY.Transporter) {
        this.IsChangedTransDriVeh = false;
      } else {
        this.IsChangedTransDriVeh = true;
      }
    // }
    this.GetEwayLrData(this.data.BookingId, this.data.ConsignmentDetailId)
  }

  GetTransporterList(value, isScrollDown = false) {
    this.Transporter.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.Transporter.dropdownList.length / 20) + 1;
    }
    this.orderService.TransporterSelect2(value, pageNo, this.TenantId).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.Transporter.dropdownList.length) {
        dropdownList = dropdownList.concat(this.Transporter.dropdownList);
        this.Transporter = { ...this.Transporter, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.Transporter = { ...this.Transporter, dropdownList: [...dropdownList] });
      this.Transporter.isSearch = false;
    }).catch(error => {
      this.Transporter.isSearch = false;
    })
  }

  GetVehicleNoList(value, isScrollDown = false) {
    this.VehicleNo.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.VehicleNo.dropdownList.length / 40) + 1;
    }
    this.orderService.GetBookingVehicleNoSelect2(value, pageNo, this.dataY.Transporter, this.dataY.VehicleType).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.VehicleNo.dropdownList.length) {
        dropdownList = dropdownList.concat(this.VehicleNo.dropdownList);
        this.VehicleNo = { ...this.VehicleNo, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.VehicleNo = { ...this.VehicleNo, dropdownList: [...dropdownList] });
      this.VehicleNo.isSearch = false;
    }).catch(error => {
      this.VehicleNo.isSearch = false;
    })
  }

  GetDriverList(value, isScrollDown = false) {
    this.Driver.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.Driver.dropdownList.length / 40) + 1;
    }
    this.orderService.GetDriverSelect2(value, pageNo, this.dataY.Transporter).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.Driver.dropdownList.length) {
        dropdownList = dropdownList.concat(this.Driver.dropdownList);
        this.Driver = { ...this.Driver, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.Driver = { ...this.Driver, dropdownList: [...dropdownList] });
      this.Driver.isSearch = false;
    }).catch(error => {
      this.Driver.isSearch = false;
    })
  }

  GetReasonList(value, isScrollDown = false) {
    this.Reason.isSearch = true;
    let type = 'Change Transporter Driver and Vehicle'
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.Reason.dropdownList.length / 20) + 1;
    }
    this.orderService.ReasonSelect2(value, pageNo, type).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.Reason.dropdownList.length) {
        dropdownList = dropdownList.concat(this.Reason.dropdownList);
        this.Reason = { ...this.Reason, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.Reason = { ...this.Reason, dropdownList: [...dropdownList] });
      this.Reason.isSearch = false;
    }).catch(error => {
      this.Reason.isSearch = false;
    })
  }

  getChangedValue(value, data) {
    const newValue = value && typeof value === 'object' && 'value' in value ? value.value : value;
    if (data.dataField == 'Transporter') {
      this.dataY[data.dataField] = value.value;
      this.dataY.TransporterType = value.TransporterType;
    } else if (data.dataField == 'VehicleNo') {
      this.dataY[data.dataField] = value.value;
    } else if (data.dataField == 'Driver') {
      this.dataY[data.dataField] = value.value;
      this.dataY.driverName = value.value;
      const mobileNo = value.MobileNo;
      const parsedMobile = Number(mobileNo);
      // Check if it's a valid number before assigning
      this.dataY.DriverMobileNo = !isNaN(parsedMobile) ? parsedMobile : 0;
      // this.data.DriverMobileNo = value.MobileNo;
      this.dataY.DriverLicense = value.LicenseNo;
      this.dataY.RCBookNo = value.RCBookNo;
      this.dataY.ChassisNo = value.ChassisNo;
      this.dataY.EngineNo = value.EngineNo;
    } else if (data.dataField == 'Reason') {
      this.dataY[data.dataField] = value.value;
    } else if (newValue) {
      this.dataY[data.dataField] = newValue;
    }
    // if (this.EwayBillFiling) {
    if (this.VehicleIdForEway === this.dataY.VehicleNo && this.TransporterIdForEway === this.dataY.Transporter) {
        this.IsChangedTransDriVeh = false;
      } else {
        this.IsChangedTransDriVeh = true;
      }
    // }
  }

  UpdateTranDriverVehicleNo() {
    this.isFormSubmit = true;
    if (this.ValidateData()) {
      var changeAssignVehcle: any = {};
      changeAssignVehcle.bookingId = this.data.BookingId;;
      changeAssignVehcle.TransporterId = this.dataY.Transporter;
      changeAssignVehcle.vehicleNo = this.dataY.VehicleNo;
      changeAssignVehcle.rcBookNo = this.dataY.RCBookNo;
      changeAssignVehcle.chassisNo = this.dataY.ChassisNo;
      changeAssignVehcle.engineNo = this.dataY.EngineNo;
      changeAssignVehcle.transporterType = this.dataY.TransporterType;
      changeAssignVehcle.driverName = this.dataY.driverName;
      changeAssignVehcle.DriverMobileNo = this.dataY.DriverMobileNo;
      changeAssignVehcle.licenseNo = this.dataY.DriverLicense;
      changeAssignVehcle.UserId = this.userId;
      changeAssignVehcle.Reason = this.dataY.Reason;

      this._appService.Post("BookingOrigin", "changeTransDriverOfBooking", changeAssignVehcle).subscribe((response) => {
        this.toastr.success('Succssfully Saved!', 'Ok');
        // this.IsChangedTransDriVeh = this.data.Reason;
        // this.GetOrderVehicleById(this.SelectedId);
        // this.modalRef.close();
        this.closeModal();
      },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      });
    }
  }

  GetEwayLrData(BookingId, ConsignmentDetailId) {
    this.Eway.GetEwayLrData(BookingId, ConsignmentDetailId).then(data => {
      if (data) {
        this.EwayConsignmentList = data;
      }
    })
    .catch(err => {
      console.error(err);
    });
  }

  UpdateEwayFilePartB(){
    this.isFormSubmit = true;
    if (this.ValidateData()) {
      this.EwayConsignmentList[0].ewayCreatedDate = this.data.EwayCreatedDate;
      this.EwayConsignmentList[0].eway_bill_number = this.dataY.EwayBillNo;
      this.EwayConsignmentList[0].vehicle_number = this.dataY.VehicleNo;
      return this.Eway.GenerateEwayPartB(this.EwayConsignmentList, this.userId, this.data.BookingId, this.data.ConsignmentDetailId).then(res => {
        if (res.success) {
          this.toastr.success('E-Waybill updated successfully!');
        } else {
          this.toastr.warning(res.errorMessage);
        }
      }).catch(err => {
        return Promise.resolve();
      });
    }
  }

  ValidateData() {
    
    var IsAllDataDone: any = true;
    if (!this.dataY.Transporter) {
      IsAllDataDone = false;
    }
    if (!this.dataY.VehicleNo && !this.dataY.VehicleNo.trim()) {
      IsAllDataDone = false;
    }
    if (!this.dataY.Driver) {
      IsAllDataDone = false;
    }
    if (!this.dataY.DriverMobileNo) {
      IsAllDataDone = false;
    }
    if (!this.dataY.Reason) {
      IsAllDataDone = false;
    }
    if (!IsAllDataDone) {
      var RequiredError = this.translate.instant("DriverDetailsById.RequiredError");
      this.toastr.error(RequiredError, "error");
    }
    return IsAllDataDone;
  }

  closeModal() {
    this.onCloseEvent.emit();
  }

}
